import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  CircularProgress,
} from "@mui/material";
import { toast } from "react-toastify";
import api from "../../../services/api";

const SetContactAddress = () => {
  const [address, setAddress] = useState("");
  const [loading, setLoading] = useState(false);
  const [isFetching, setIsFetching] = useState(false);

  useEffect(() => {
    setIsFetching(true)
    api.admin.getContactAddress()
      .then((res) => {
        setAddress(res.data['Contact-address'][0].value || "N/A");
      })
      .catch((err) => {
        toast.error("Failed to get Contact Address.");
        console.error("Error getting Contact Address:", err);
      })
      .finally(() => {
        setIsFetching(false);
      });
  }, [])

  const handleInputChange = (e) => {
    setAddress(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    const formData = new FormData();
    formData.append("address", address);

    api.admin.setContactAddress(formData)
      .then((res) => {
        console.log(res)
        toast.success("Contact Address updated successfully!");
        setAddress("");
      })
      .catch((err) => {
        toast.error("Failed to set Contact Address.");
        console.error("Error updating contact address:", err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Box
      component="form"
      onSubmit={handleSubmit}
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        maxWidth: 400,
        margin: "0 auto",
        padding: 2,
        boxShadow: 3,
        borderRadius: 1,
        backgroundColor: "white",
      }}
    >
      <Typography variant="h5" component="h2" gutterBottom>
        Set Contact Address
      </Typography>
      {isFetching ? <CircularProgress /> :<TextField
        label="Contact Address"
        variant="outlined"
        name="address"
        value={address}
        onChange={handleInputChange}
        fullWidth
        required
        sx={{ marginBottom: 2 }}
      />}
      <Button type="submit" variant="contained" color="primary" disabled={loading}>
        {loading ? <CircularProgress size={24} /> : "Submit"}
      </Button>
    </Box>
  );
};

export default SetContactAddress